var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('title-row', {
    attrs: {
      "title": "Hozzáférési szintek",
      "subtitle": _vm.dataTable.itemsLength === -1 ? 'Betöltés...' : `${_vm.dataTable.itemsLength} hozzáférési szint van a rendszerben`,
      "breadcrumb-items": [{
        text: 'Hozzáférési szintek',
        disabled: true
      }]
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_vm.hasRight('ACCESS_LEVEL_WRITE') ? _c('title-row-button', {
          attrs: {
            "to": {
              name: 'NewAccessLevel'
            },
            "title": "Hozzáadás"
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-plus")]), _vm._v(" Új hozzáférési szint ")], 1) : _vm._e()];
      },
      proxy: true
    }])
  }), _c('v-expansion-panels', {
    staticClass: "mb-4 rounded-xl overflow-hidden",
    attrs: {
      "mandatory": !!Object.values(_vm.search).find(function (e) {
        return e !== '';
      }),
      "flat": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('span', {
    staticClass: "font-weight-medium"
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-magnify")]), _vm._v(" Keresés ")], 1)]), _c('v-expansion-panel-content', [_c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": 12,
      "sm": 4,
      "md": 3
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Megnevezés",
      "clearable": "",
      "hide-details": "",
      "filled": ""
    },
    on: {
      "input": _vm.searchEventHandler
    },
    model: {
      value: _vm.search.name,
      callback: function ($$v) {
        _vm.$set(_vm.search, "name", $$v);
      },
      expression: "search.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": 12,
      "sm": 4,
      "md": 3
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Csoport",
      "items": _vm.groups,
      "item-text": "name",
      "item-value": "element_id",
      "hide-details": "",
      "clearable": "",
      "filled": ""
    },
    on: {
      "change": _vm.searchEventHandler,
      "click:clear": _vm.searchEventHandler
    },
    model: {
      value: _vm.search.group_id,
      callback: function ($$v) {
        _vm.$set(_vm.search, "group_id", $$v);
      },
      expression: "search.group_id"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "flat": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "loading": _vm.loading,
      "headers": _vm.dataTable.headers,
      "items": _vm.dataTable.items,
      "server-items-length": _vm.dataTable.itemsLength,
      "options": _vm.dataTable.options,
      "footer-props": _vm.$config.dataTableFooterProps
    },
    on: {
      "update:options": function ($event) {
        return _vm.$set(_vm.dataTable, "options", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: `item.groups`,
      fn: function (_ref) {
        var item = _ref.item;
        return _vm._l(item.groups, function (group, index) {
          return _c('v-chip', {
            key: `group-${group.element_id}-${index}`,
            staticClass: "ma-1 rounded-xl",
            attrs: {
              "link": "",
              "label": "",
              "small": "",
              "to": {
                name: 'GroupEditor',
                params: {
                  id: group.element_id
                }
              }
            }
          }, [_vm._v(" " + _vm._s(group.name) + " ")]);
        });
      }
    }, {
      key: `item.actions`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm.hasRight('ACCESS_LEVEL_WRITE') ? _c('v-btn', {
          staticClass: "rounded-xl mr-1",
          attrs: {
            "text": "",
            "fab": "",
            "small": "",
            "dark": "",
            "color": "primary",
            "to": {
              name: 'AccessLevelEditor',
              params: {
                id: item.element_id
              }
            },
            "title": "Szerkesztés"
          }
        }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1) : _vm._e(), _vm.hasRight('ACCESS_LEVEL_WRITE') ? _c('v-btn', {
          staticClass: "rounded-xl mr-1",
          attrs: {
            "text": "",
            "fab": "",
            "small": "",
            "dark": "",
            "color": "primary",
            "disabled": !item.erasable,
            "title": "Törlés"
          },
          on: {
            "click": function ($event) {
              return _vm.deleteAccessLevel(item);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-delete")])], 1) : _vm._e(), Number(_vm.$store.state.user.superadmin) && _vm.copyId == null ? _c('v-btn', {
          staticClass: "rounded-xl mr-1",
          attrs: {
            "text": "",
            "fab": "",
            "small": "",
            "dark": "",
            "color": "primary",
            "title": "Másolás"
          },
          on: {
            "click": function ($event) {
              _vm.copyId = item.element_id;
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-content-copy")])], 1) : Number(_vm.$store.state.user.superadmin) && _vm.copyId == item.element_id ? _c('v-btn', {
          staticClass: "rounded-xl mr-1",
          attrs: {
            "text": "",
            "fab": "",
            "small": "",
            "dark": "",
            "color": "primary",
            "title": "Kilépés a másolásból"
          },
          on: {
            "click": function ($event) {
              _vm.copyId = null;
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-close")])], 1) : Number(_vm.$store.state.user.superadmin) && _vm.copyId != item.element_id ? _c('v-btn', {
          staticClass: "rounded-xl mr-1",
          attrs: {
            "text": "",
            "fab": "",
            "small": "",
            "dark": "",
            "color": "primary",
            "title": "Beillesztés"
          },
          on: {
            "click": function ($event) {
              return _vm.fetchAccessLevelAssets(item.element_id, _vm.copyId);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-content-paste")])], 1) : _vm._e()];
      }
    }], null, true)
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }